import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import styles from './ArticleTitle.module.css';
import PropTypes from 'prop-types';

const ArticleTitle = ({ children }) => {
  const {
    articleTitle,
    articleTitleTextAlign: textAlign,
    articleTitleFontWeight: fontWeight,
    articleTitleFontColor: color,
    articleTitleFontFamily: fontFamily,
  } = useSearchParamOrDefaultProps();

  const style = {
    textAlign,
    fontWeight,
    color,
    fontFamily,
  };

  return (
    <article className={styles.articleTitleWrapper}>
      <div className={styles.articleTitle} style={style}>
        {children ? children : articleTitle}
      </div>
    </article>
  );
};

ArticleTitle.displayName = 'ArticleTitle';

ArticleTitle.propTypes = {
  children: PropTypes.node,
};

ArticleTitle.defaultProps = {
  children: null,
};

export default ArticleTitle;
